import {
  createAction,
  joinActions,
  props,
} from "../../helpers/store/actions-helpers";
import { WebChat } from "../interfaces/api/get-web-chat";
import { WebMessage } from "../interfaces/api/get-messages";
import { Avatar } from "../interfaces/avatar";
import { Conversation } from "../interfaces/api/get-conversations";

export const setChatAction = createAction(
  "[WebChat] Set Chat",
  props<{ chat: WebChat }>()
);

export const setSelectedConversationAction = createAction(
  "[WebChat] Select Conversation",
  props<{ id: string | null }>()
);

export const addWebMessageAction = createAction(
  "[WebChat] Set new Message",
  props<{ message: WebMessage, id: string }>()
);

export const setAvatarAction = createAction(
  "[WebChat] Set Avatar",
  props<{ avatar: Avatar | null }>()
);

export const addConversationAction = createAction(
  "[WebChat] Add Conversation",
  props<{ conversation: Conversation }>()
);

const actions = joinActions({
  setChatAction,
  setSelectedConversationAction,
  addWebMessageAction,
  setAvatarAction,
  addConversationAction,
});

export type WebChatAction = typeof actions;
